import React, { Component, useRef } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import {getResponseObjective} from '../../../../../services/getResponseObjective'

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';

import moment from 'moment'
import 'moment/locale/es'  
import { COLORS } from '../../../../../utils/colors';
import compose from 'recompose/compose';
import { useTranslation, withTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')

class ResponseTimeGeneral extends Component {

    constructor(props) {
        super(props);

        // Referencia al componente del gráfico (compatible desde React 16.3+)
        this.chartComponentRef = React.createRef();

        // Vincular el método a la clase
        this.toggleAllSeries = this.toggleAllSeries.bind(this);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase(),
            chartOptions: this._chartOptionsBase(),
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            schedule:0,
            allVisible:true
        }  
    }
    
    _chartOptionsBase = () => {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        return {
        chart: {
            type: 'spline',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            },
        },
        title: {
            text: "",
            style: {
                fontSize: '20px' 
             },
             margin: 25,
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: '',
                fontSize: '',
            }
        },
        xAxis: {
            lineColor: '#c0c0c0',
            type: 'datetime',
            minorGridLineColor: '#E0E0E0',
            minorTickLength: 0,
            gridLineWidth: 0.3,
            showFirstLabel: true,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
            /*title: {
                useHTML:true,
                style: { color: '#5A5A5A', fontSize: '12px', fontWeight: 'bold' },
                text: '<br/>Período'
            },	*/
            labels: {
                useHTML: true,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: t('response-time-general.graph.title')
            },
            plotLines: []
        },
        setOptions: {
            time: {
                useUTC: false
            },
            lang: {
                months: t('months', { returnObjects: true }),
                weekdays: t('weekDays', { returnObjects: true }),
                locale: 'pt-PT',
            }
        },
        plotOptions: {
            series: {
                turboThreshold: 20000,
                gapSize: 2,
                marker: {
                    symbol: 'circle',
                    width: 8,
                    height: 8,
                    enabled: false
                },
            },

        },

        legend: {
            enabled: true,
            useHTML: true,
            symbolWidth: 0,
            labelFormatter: function() {
                let symbol = '<div style="background:' + this.color + ';width:15px;height:3px;margin-top:5px"></div>'
                let name= '<button style="padding-left:4px;border-width:0px;background:white">'+this.name+'</button>'
                return '<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;">' + symbol + ' ' + name + '</div>'
              }
        },
        navigator: {
            enabled: null
        },
        tooltip: {
            enabled: false,
            pointFormat: t('response-time-step.graph.tooltip.point-format') + ': <b>{point.y:.2f} (s)</b>'
        },
        credits: {
            enabled: false
        },
        series: []

    }
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = (objectiveId) => {    
        this.setState({
            isLoading: true,
        }) 
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, schedule } = this.props.params
        const { history } = this.props;
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            // fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            // correccion para que la fecha sea hora local
            fecha_termino = moment(statePeriod.endDate).format().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalObjetivoCustom/?objetivoId=${objetivo_id}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=${schedule}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino,
                                schedule)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    reportFetchError('ResponseTimeGeneral', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });
        } else {
            getResponseObjective(objetivo_id,token,period)
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino,
                                schedule)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                })
                .catch(error => {
                    reportFetchError('ResponseTimeGeneral', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });
        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino,
        schedule) => {
        let arrayChartData = []
        let lastEventDict = []
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        let ValueNavigator = false
        /*if (period === 'w' || fecha_inicio !== null) {
            ValueNavigator = true
        }*/
       const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (schedule == 0){
            Object.keys(externalData.Objetivo.Paso).map((key) => {
                let chartDataSeries = {}
                let arrayData = []
                let rowLen = externalData.Objetivo.Paso[key].rendimientoDetalle.length;
    
                externalData.Objetivo.Paso[key].rendimientoDetalle.forEach((item, forEachKey) => {
                    var dict = {};
                    let date = new Date(item.inicio)
                    let year = date.getFullYear()
                    let month = date.getMonth()
                    let day = date.getDate()
                    let hours = date.getHours()
                    let minutes = date.getMinutes()
                    let seconds = date.getSeconds()
                    dict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                    dict['y'] = item.respuesta
                    arrayData.push(dict)
                    if (forEachKey == (rowLen - 1) && key == 0) {
                        lastEventDict['x'] = dict['x']
                        lastEventDict['y'] = dict['y']
                        lastEventDict['name'] = externalData.Objetivo.Paso[key].paso_nombre;
                        if (period === 'h') {
                            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
                        } else if (period === 'd') {
                            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                        } else if (period === 'w') {
                            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                        } else if (period === 'c') {
                            lastEventDict['namePeriod'] = `${t('text.range')}: ` + fecha_inicio + ` ${t('text.to2')} ` + fecha_termino
                        }
                    }
                });
                chartDataSeries['name'] = externalData.Objetivo.Paso[key].paso_nombre;
                chartDataSeries['color'] = colors[key]
                chartDataSeries['data'] = arrayData
                arrayChartData.push(chartDataSeries)
            })
        } else {
            Object.keys(externalData.Objetivo.Paso).map((key) => {
                Object.keys(externalData.Objetivo.Paso[key].estado).map((keyEstado) => {
                    let chartDataSeries = {}
                    let arrayData = []
                    let rowLen = externalData.Objetivo.Paso[key].estado[keyEstado].rendimientoDetalle.length;
                    externalData.Objetivo.Paso[key].estado[keyEstado].rendimientoDetalle.forEach((item, forEachKey) => {
                        var dict = {};
                        let date = new Date(item.inicio)
                        let year = date.getFullYear()
                        let month = date.getMonth()
                        let day = date.getDate()
                        let hours = date.getHours()
                        let minutes = date.getMinutes()
                        let seconds = date.getSeconds()
                        dict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                        dict['y'] = item.respuesta
                        arrayData.push(dict)
                        if (forEachKey == (rowLen - 1) && key == 0) {
                            lastEventDict['x'] = dict['x']
                            lastEventDict['y'] = dict['y']
                            lastEventDict['name'] = externalData.Objetivo.Paso[key].estado[keyEstado].paso_nombre;
                            if (period === 'h') {
                                lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
                            } else if (period === 'd') {
                                lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                            } else if (period === 'w') {
                                lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                            } else if (period === 'c') {
                                lastEventDict['namePeriod'] = `${t('text.range')}: ` + fecha_inicio + ` ${t('text.to2')} ` + fecha_termino
                            }
                        }
                    });
                    chartDataSeries['name'] = externalData.Objetivo.Paso[key].estado[keyEstado].paso_nombre;
                    chartDataSeries['color'] = colors[key]
                    chartDataSeries['data'] = arrayData
                    arrayChartData.push(chartDataSeries)

                })
            })
            const result = Object.groupBy(arrayChartData, ({ name }) => name);
            arrayChartData = []
            Object.keys(result).map((key) => {
                let chartDataSeries = {}
                let arrayData = []
                Object.keys(result[key]).map((keyData ) => {
                    Object.keys(result[key][keyData].data).map((keyDataIndividual) => {
                        arrayData.push(result[key][keyData].data[keyDataIndividual])
                    })
                })
                const resultData = Object.groupBy(arrayData, ({ x }) => x);
                arrayData = []
                Object.keys(resultData).map((key) => {
                    var dict = {};
                    var sumY = 0;
                    Object.keys(resultData[key]).map((keyY) => {
                        sumY = sumY + resultData[key][keyY].y
                    })
                    dict['y'] = sumY
                    dict['x'] = resultData[key][0].x
                    arrayData.push(dict)
                })
                arrayData.sort(function(a, b) {
                    return a.x - b.x;
                })
                
                chartDataSeries['name'] = result[key][0].name;
                chartDataSeries['color'] = colors[key]
                chartDataSeries['data'] = arrayData
                arrayChartData.push(chartDataSeries)
            })
        }
        
        
        const arrayChartDataMarked = externalData.Objetivo.Peridos_Marcados.map(item => {
            let chartDataSeries = {}
            if (item.id_tipo_marcado === 7){
                chartDataSeries['from'] = ""
                chartDataSeries['to'] =  ""
                chartDataSeries['color'] = ""
                chartDataSeries['zIndex'] = 1
            }
            if (item.id_tipo_marcado === 9){
                let dateStart = new Date(item.fecha_inicio)
                let dateEnd = new Date(item.fecha_termino)
                chartDataSeries['from'] = Date.UTC(dateStart.getFullYear(dateStart), dateStart.getMonth(dateStart), dateStart.getDate(dateStart), dateStart.getHours(dateStart), dateStart.getMinutes(dateStart), dateStart.getSeconds(dateStart))
                chartDataSeries['to'] = Date.UTC(dateEnd.getFullYear(dateEnd), dateEnd.getMonth(dateEnd), dateEnd.getDate(dateEnd), dateEnd.getHours(dateEnd), dateEnd.getMinutes(dateEnd), dateEnd.getSeconds(dateEnd))
                chartDataSeries['color'] = COLORS.EVENTO_CLIENTE
                chartDataSeries['zIndex'] = 1
            }
            if (item.id_tipo_marcado === 10){
                let dateStart = new Date(item.fecha_inicio)
                let dateEnd = new Date(item.fecha_termino)
                chartDataSeries['from'] = Date.UTC(dateStart.getFullYear(dateStart), dateStart.getMonth(dateStart), dateStart.getDate(dateStart), dateStart.getHours(dateStart), dateStart.getMinutes(dateStart), dateStart.getSeconds(dateStart))
                chartDataSeries['to'] = Date.UTC(dateEnd.getFullYear(dateEnd), dateEnd.getMonth(dateEnd), dateEnd.getDate(dateEnd), dateEnd.getHours(dateEnd), dateEnd.getMinutes(dateEnd), dateEnd.getSeconds(dateEnd))
                chartDataSeries['color'] = COLORS.MARCADO_ATENTUS
                chartDataSeries['zIndex'] = 1
            }
            return chartDataSeries
            }
        )
        const self = this;
        const isAllVisible = this.state.allVisible;
        this.setState({
            chartOptions: {
                chart: {
                    type: 'spline',
                    zoomType: 'x',
                    ignoreHiddenSeries: false,
                    marginRight: 30,
                    resetZoomButton: {
                        theme: {
                            fill: 'white',
                            stroke: 'silver',
                            r: 0,
                            states: {
                                hover: {
                                    fill: '#41739D',
                                    style: { color: 'white' }
                                }
                            }
                        }
                    }
                },
                title: null,
                subtitle: null,
                xAxis: {
                    lineColor: '#c0c0c0',
                    type: 'datetime',
                    minorGridLineColor: '#E0E0E0',
                    minorTickLength: 0,
                    gridLineWidth: 0.3,
                    showFirstLabel: true,
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S%P',
                        minute: '%l:%M%P',
                        hour: '%H:%M',
                        day: '<br/><b>%e/%b</b>',
                        week: '%e. %b',
                        month: '%b %y',
                        year: '%Y'
                    },
                    labels: {
                        useHTML: true,
                    },
                    plotBands: arrayChartDataMarked,
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: t('response-time-general.graph.title')
                    },
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                plotOptions: {
                    series: {
                        events: {
                            legendItemClick: () => {
                                setTimeout(() => {
                                    this.checkAllVisible();
                                }, 10);
                            }
                        },
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        },
                        turboThreshold: 20000,
                        gapSize: 2,
                        marker: {
                            symbol: 'circle',
                            width: 8,
                            height: 8,
                            enabled: false
                        },
                    },
                },
                legend: {
                    enabled: true,
                    useHTML: true,
                    align: 'center', // O la alineación general que uses
                    verticalAlign: 'bottom',
                    title: {
                        text: this.getToggleButtonHtml(
                            this.state.allVisible ? t('text.hide-step') : t('text.show-step')
                        ),
                        style: {
                            fontWeight: 'normal'
                        }
                    },
                    symbolWidth: 0,
                    labelFormatter: function () {
                        // Re-vinculamos el evento 'onclick' en cada render del ítem de la leyenda
                        setTimeout(() => {
                            const btn = document.getElementById('custom-toggle-btn');
                            if (btn) {
                                btn.onclick = () => {
                                    if (self && typeof self.toggleAllSeries === 'function') {
                                        self.toggleAllSeries();
                                    }
                                };
                            }
                        }, 0);
            
                        const isVisible = this.visible;
                        const opacity = isVisible ? '1' : '0.65';
                        const textColor = isVisible ? '#333333' : '#666666';
                        const lineThrough = isVisible ? 'none' : 'line-through';
            
                        let symbol = `<div style="background:${this.color};width:15px;height:3px;margin-top:5px;opacity:${opacity};"></div>`;
                        let name = `<button style="padding-left:4px;border-width:0px;background:transparent;color:${textColor};text-decoration:${lineThrough};opacity:${opacity};cursor:pointer;">${this.name}</button>`;
            
                        return `<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;opacity:${opacity};">${symbol} ${name}</div>`;
                    }
                },
                tooltip: {
                    enabled: false,
                    pointFormat: t('response-time-step.graph.tooltip.point-format') + ': <b>{point.y:.2f} (s)</b>'
                },
                navigator: {
                    enabled: false
                },
                series: [
                    ...arrayChartData
                ]                
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this._chartOptionsBase(),
                xAxis: {
                    ...this._chartOptionsBase().xAxis,
                    plotBands: arrayChartDataMarked
                },
                yAxis: {
                    ...this._chartOptionsBase().yAxis,
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                series: arrayChartData
            }
        });

    }

    toggleAllSeries(forcedState) {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (!chart) return;
    
        const nextState = typeof forcedState === 'boolean' ? forcedState : !this.state.allVisible;
    
        chart.series.forEach((series) => {
            if (nextState) {
                series.show(false);
            } else {
                series.hide(false);
            }
        });
    
        this.setState({ allVisible: nextState }, () => {
            // Actualizamos el título de la leyenda para refrescar el texto del botón
            const btnText = nextState ? t('text.hide-step') : t('text.show-step');
            chart.update({
                legend: {
                    title: {
                        text: this.getToggleButtonHtml(btnText)
                    }
                }
            });
        });
    }
    
    checkAllVisible() {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (!chart) return;
    
        const isAnyVisible = chart.series.some(series => series.visible);
    
        if (this.state.allVisible !== isAnyVisible) {
            this.setState({ allVisible: isAnyVisible }, () => {
                const btnText = isAnyVisible ? t('text.hide-step') : t('text.show-step');
                chart.update({
                    legend: {
                        title: {
                            text: this.getToggleButtonHtml(btnText)
                        }
                    }
                });
            });
        }
    }
    
    // Método auxiliar para generar la estructura HTML del botón
    getToggleButtonHtml(btnText) {
        return `
            <button 
                id="custom-toggle-btn"
                style="
                    background: #ffffff;
                    border: 1px solid #cccccc;
                    border-radius: 4px;
                    color: #333333;
                    font-size: 11px;
                    cursor: pointer;
                    padding: 4px 8px;
                    white-space: nowrap;
                "
            >
                ${btnText}
            </button>
        `;
    }

    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase, allVisible } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoading) {
            return (
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
        }
        if (!dataError && chartOptionsBase.series.length > 0) {
            sessionStorage.setItem("chartResponseTimeGeneral",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} allVisible={allVisible} toggleAllSeries={this.toggleAllSeries} chartRef={this.chartComponentRef} t= {t}/>)
        }
        else if (dataError) {
            return (<p>{t('modal.objective.render.no-data')}</p>)
        }
        else return (<p>{t('modal.objective.render.error')}</p>)

    }
}

function FormattedChart(props) {
    return (
        <div>
            <div style={props.style}>
                <HighchartsReact
                    ref={props.chartRef}
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default compose(withRouter, withTranslation())(ResponseTimeGeneral);